import { addDays, addMonths, endOfDay, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek, subMonths, subWeeks } from 'date-fns';

export interface ReportDateRange {
    label_intl: string;
    range: () => { startDate: Date, endDate: Date };
}

export const today: ReportDateRange = {
    label_intl: 'today',
    range: () => ({
        startDate: startOfDay(new Date()),
        endDate: endOfDay(new Date())
    })
};

export const yesterday: ReportDateRange = {
    label_intl: 'yesterday',
    range: () => ({
        startDate: addDays(startOfDay(new Date()), -1),
        endDate: endOfDay(addDays(startOfDay(new Date()), -1))
    })
};

export const lastWeek: ReportDateRange = {
    label_intl: 'last_week',
    range: () => {
        const today = new Date();
        const startOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
        const startOfLastWeek = subWeeks(startOfCurrentWeek, 1);
        const endOfLastWeek = endOfWeek(startOfLastWeek, { weekStartsOn: 1 });
        return {
            startDate: startOfLastWeek,
            endDate: endOfLastWeek
        }
    }
};

export const thisWeek: ReportDateRange = {
    label_intl: 'this_week',
    range: () => ({
        startDate: startOfWeek(new Date(), {weekStartsOn: 1}),
        endDate: endOfDay(new Date())
    })
};

export const lastMonth: ReportDateRange = {
    label_intl: 'last_month',
    range: () => {
        const today = new Date();
        const startOfCurrentMonth = startOfMonth(today);
        const startOfLastMonth = subMonths(startOfCurrentMonth, 1);
        const endOfLastMonth = endOfMonth(startOfLastMonth);

        return {
            startDate: startOfLastMonth,
            endDate: endOfLastMonth
        }
    }
};

export const thisMonth: ReportDateRange = {
    label_intl: 'this_month',
    range: () => ({
        startDate: startOfMonth(new Date()),
        endDate: endOfDay(new Date())
    })
};

export const last7Days: ReportDateRange = {
    label_intl: 'last_7_days',
    range: () => ({
        startDate: addDays(startOfDay(new Date()), -6),
        endDate: endOfDay(new Date())
    })
};

export const last31Days: ReportDateRange = {
    label_intl: 'last_31_days',
    range: () => ({
        startDate: addDays(startOfDay(new Date()), -30),
        endDate: endOfDay(new Date())
    })
};

export const last12Months: ReportDateRange = {
    label_intl: 'last_12_months',
    range: () => ({
        startDate: addMonths(startOfDay(new Date()), -12),
        endDate: endOfDay(new Date())
    })
};